<template>
  <div>
    <div class="row-col primary">
      <div 
        v-for="(stat, idx) in stats[0]" 
        :class="{dker: (idx % 2) == 0}"
        :key="idx"
        class="row-cell">
        <div class="p-a-md">
          <span class="h5 _500 clear m-b-0">{{ stat.name }}</span>
          <small class="text-muted">{{ stat.desc }}</small>
          <div class="clearfix m-b-sm"/>
          <span 
            v-for="outlet in stat.outlets" 
            :key="outlet.id" 
            class="_500 clear">
            {{ getDisplayFormat(outlet, stat.id) }}
          </span>
          <span 
            v-show="!stat.outlets.length && !loading" 
            class="m-b-sm clear">
            <i>No record found</i>
          </span>
          <i 
            v-show="loading" 
            class="fa fa-spinner fa-spin fa-2x"/>
        </div>
      </div>
    </div>

    <div class="row-col primary">
      <div 
        v-for="(stat, idx) in stats[1]" 
        :class="{dker: (idx % 2) != 0}"
        :key="idx"
        class="row-cell">
        <div class="p-a-md">
          <span class="h5 _500 clear m-b-0">{{ stat.name }}</span>
          <small class="text-muted">{{ stat.desc }}</small>
          <div class="clearfix m-b-sm"/>
          <span 
            v-for="outlet in stat.outlets" 
            :key="outlet.id" 
            class="_500 clear">
            {{ getDisplayFormat(outlet, stat.id) }}
          </span>
          <span 
            v-show="!stat.outlets.length && !loading" 
            class="m-b-sm clear">
            <i>No record found</i>
          </span>
          <i 
            v-show="loading" 
            class="fa fa-spinner fa-spin fa-2x"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import numeral from 'numeral';

export default {
    data() {
        return {
            loading: true,
            stats: [
                [
                    {
                        id: 'top_outlet_sales',
                        name: 'Top Outlet Sales',
                        desc:
                            'Quick view of the sales prior of the month sales',
                        outlets: [],
                    },
                    {
                        id: 'top_outlet_pax',
                        name: 'Top Outlet Pax',
                        desc:
                            'Quick view of the pax prior of the month to date',
                        outlets: [],
                    },
                    {
                        id: 'top_item_sales',
                        name: 'Top Product Sales',
                        desc: 'Top item sales prior of the month to date',
                        outlets: [],
                    },
                ],
                [
                    {
                        id: 'top_voided_receipt',
                        name: 'Top Outlet Voided Receipt',
                        desc: 'Quick view of outlet with voided sales',
                        outlets: [],
                    },
                    {
                        id: 'top_average_receipt',
                        name: 'Top Average Spending Per Receipt',
                        desc: 'Quick view of top average spending per receipt',
                        outlets: [],
                    },
                    {
                        id: 'top_average_pax',
                        name: 'Top Average Spending Per Pax',
                        desc: 'Quick view of top average spending per pax',
                        outlets: [],
                    },
                ],
            ],
        };
    },

    computed: {
        api() {
            return Laroute.route('franchise.dashboard.stats');
        },
    },

    created: function() {
        this.getDashboardStats();
    },

    methods: {
        getDashboardStats() {
            this.$http.get(this.api).then(res => {
                this.loading = false;
                let data = res.data;
                for (let i = 0; i < 2; i++) {
                    this.stats[i].forEach((obj, key) => {
                        obj.outlets = data[obj.id];
                    });
                }
            });
        },

        getDisplayFormat(data, type) {
            let outlet;
            switch (type) {
                case 'top_outlet_sales':
                case 'top_average_receipt':
                case 'top_average_pax':
                    outlet =
                        numeral(data.total).format('0,0.00') + ' ' + data.name;
                    break;
                case 'top_outlet_pax':
                    outlet = data.total + ' Pax ' + data.name;
                    break;
                case 'top_item_sales':
                    outlet =
                        data.product_name +
                        ' ' +
                        data.total +
                        ' Unit ' +
                        data.name;
                    break;
                case 'top_voided_receipt':
                    outlet = data.total + ' Voided Receipt ' + data.name;
                    break;
            }

            return outlet;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/dashboard/dashboard.vue